<template>
  <div>
    <CRow class="content-fade-in">
      <CCol md="12">
        <CCard>
          <CCardBody>
            <CForm class="form-basic">
              <CRow>
                <CCol sm="6" md="6" xl="6">
                  <BaseInput :options="titleInput.options" :data="titleInput.data" />
                </CCol>
                <CCol sm="6" md="6" xl="6">
                  <div class="form-input-wrapper">
                    <div class="form-group">
                      <label class="form-label" for="uploadFile">Chọn bản tin<span class='required'> *</span></label>
                      <div class="custom-file"
                        :class="selectedFiles.data.validator.isValid == false ? 'input-valid-error' : ''">
                        <input type="file" class="custom-file-input" id="uploadFile" ref="file" accept=".mp3, .wav"
                          @change="selectFile($event)">
                        <label class="custom-file-label" for="uploadFile">{{ fileName }}</label>
                      </div>
                      <div class="valid-error"
                        v-show="!(selectedFiles.data.validator ? selectedFiles.data.validator.isValid : true)">
                        {{ selectedFiles.data.validator ? selectedFiles.data.validator.errorMessage : "" }}
                      </div>
                    </div>
                  </div>
                </CCol>
                <CCol xs="12" sm="6" md="6" lg="6" xl="6">
                  <BaseSelect :options="levelSelect.options" :data="levelSelect.data" ref="levelSelect"></BaseSelect>
                </CCol>
                <CCol xs="12" sm="6" md="6" lg="6" xl="6">
                  <BaseSelect :options="departmentsInput.options" :data="departmentsInput.data" ref="departmentsInput">
                  </BaseSelect>
                </CCol>
                <CCol sm="12" md="12" xl="12">
                  <BaseTextArea :options="descriptionInput.options" :data="descriptionInput.data"
                    v-model="descriptionInput.data.model" />
                </CCol>
              </CRow>
              <div slot="footer" class="mt-4">
                <CButton color="primary" class="btn-action-primary mr-2" @click="submitData(false)">
                  <i class="fa fa-plus"></i> Lưu lại
                </CButton>
                <CButton color="primary" class="btn-action-primary mr-2" @click="submitData(true)">
                  <i class="fa fa-send"></i> Lưu lại & Gửi tới đài
                </CButton>
                <CButton color="secondary" class="btn-action-primary mr-2" @click="resetData()"><i
                    class="fa fa-eraser"></i> Làm mới
                </CButton>
              </div>
              <BaseLoading :loading="loading.value"></BaseLoading>
            </CForm>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import BaseSelect from "../../base/BaseSelect2";
import BaseInput from "../../base/BaseInput";
import BaseLoading from "../../base/BaseFormLoading";
import BaseTextArea from "../../base/BaseTextArea.vue";
import { sourceType } from "@/constant";

export default {
  name: "AudioFileAdd",
  components: { BaseSelect, BaseInput, BaseLoading, BaseTextArea },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Errors"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data: function () {
    let that = this;
    return {
      loading: { value: false },
      fileName: 'Chọn tệp',
      titleInput: {
        options: {
          label: "Tiêu đề bản tin <span class='required'>*</span>",
          placeholder: "Tiêu đề bản tin",
          maxlength: 100
        },
        data: {
          name: "title",
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.titleInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Tiêu đề bản tin không được để trống";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
      sourceTypeSelect: {
        data: {
          name: "sourceType",
          model: sourceType.BIEN_TAP,
        }
      },
      descriptionInput: {
        options: {
          label: "Mô tả bản tin",
          placeholder: "Mô tả bản tin",
          maxlength: 255,
          rows: 5
        },
        data: {
          name: "description",
          model: "",
          updateCallback: function () {
            that.submitData();
          }
        }
      },
      departmentsInput: {
        options: {
          filter: true,
          label: "Lĩnh vực <span class='required'>*</span>",
          selectAllText: "Chọn lĩnh vực",
        },
        data: {
          name: "fileTypeId",
          items: [],
          model: "",
          updateCallback: function () {
            that.submitData();
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.departmentsInput.data.model;
              if (value === "") {
                this.isValid = false;
                this.errorMessage = "Lĩnh vực bản tin phải được chọn";
              } else {
                this.isValid = true;
              }
              return this.isValid;
            }
          }
        }
      },
      levelSelect: {
        options: {
          filter: false,
          label: 'Mức độ ưu tiên',
        },
        data: {
          name: "level",
          items: [
            { key: "0", value: "Bình thường" },
            { key: "1", value: "Ưu tiên" },
            { key: "2", value: "Khẩn cấp" },
          ],
          model: "0",
          updateCallback: function () {
            that.submitData();
          },
        }
      },
      selectedFiles: {
        data: {
          name: "file",
          model: {
            fileName: '',
            content: '',
            size: '',
            type: ''
          },
          validator: {
            isValid: true,
            errorMessage: "",
            valid: function () {
              let value = that.selectedFiles.data.model.fileName;
              if (value.length == 0) {
                this.isValid = false;
                this.errorMessage = "Bản tin không được để trống";
              } else {
                let type = that.selectedFiles.data.model.type;
                if (type == "audio/mpeg" || type == "audio/wav") {
                  this.isValid = true;
                  this.errorMessage = "";
                } else {
                  this.isValid = false;
                  this.errorMessage = "Sai định dạng tệp tin";
                }
              }
              return this.isValid;
            }
          }
        }
      },
      durationFile: {
        data: {
          name: "duration",
          model: '',
        }
      }
    }
  },
  methods: {
    submitData: function (isSend) {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/audio-file/addFile",
        dataRef: function () {
          return that.$data;
        },
        successCallback: function (response) {
          if (!that.$helper.validResponse(that.$router, response.data)) {
            that.showErrorMsg({ message: that.$helper.getStringError(response.data.data) });
            that.$helper.setupErrorModel(response.data.data, that.$data);
          } else {
            that.showSuccessMsg({
              message: "Thêm mới bản tin thành công"
            });
            if (isSend) {
              // console.log(response.data.data)
              that.$router.push({
                path: '/audio-editor/send-to-station.html',
                query: { fileId: response.data.data.id, sourceType: response.data.data.sourceType }
              })
            } else {
              that.$router.push('/files-device-management/managed-files.html')
            }
            // that.resetData()
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    selectFile() {
      let that = this;
      let reader = new FileReader();
      var file = this.$refs.file.files[0];
      if (file) {
        that.fileName = file.name;
        var audio = document.createElement('audio');
        reader.readAsDataURL(file);
        reader.onload = function () {
          // setTimeout(function () {
          audio.src = reader.result;
          audio.addEventListener('durationchange', function () {
            that.durationFile.data.model = (new Date(audio.duration * 1000).toISOString().substr(11, 8));
          }, false);

          that.selectedFiles.data.model.fileName = file.name;
          that.selectedFiles.data.model.content = reader.result.split(',')[1];
          that.selectedFiles.data.model.type = file.type;
          // }, 500)
        }
      }
    },
    resetData() {
      let that = this;
      // that.$helper.setupDataResponse(that.$data, {});
      that.titleInput.data.model = "";
      that.sourceTypeSelect.data.model = "1";
      that.descriptionInput.data.model = "";
      that.departmentsInput.data.model = "";
      that.levelSelect.data.model = "0";
      that.selectedFiles.data.model.fileName = "";
      that.selectedFiles.data.model.content = "";
      that.durationFile.data.model = "";
      that.fileName = "Chọn tệp";
    },
    loadDataDepartment: function () {
      let that = this;
      that.loading.value = true
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/common/listField",
        successCallback: function (response) {
          that.departmentsInput.data.items = response.data.data;
          that.loading.value = false
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
          that.loading.value = false
        }
      });
    },
  },
  computed: {},
  created() {
  },
  mounted() {
    // this.loadDataLocation();
    this.loadDataDepartment();
  },
  watch: {
    'departmentsInput.data.model': function () {
      this.departmentsInput.data.validator.valid();
    }
  }
};
</script>
